import { render, staticRenderFns } from "./courseNoteAdd.vue?vue&type=template&id=1e2f4530&scoped=true&"
import script from "./courseNoteAdd.vue?vue&type=script&lang=js&"
export * from "./courseNoteAdd.vue?vue&type=script&lang=js&"
import style0 from "./courseNoteAdd.vue?vue&type=style&index=0&id=1e2f4530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f4530",
  null
  
)

export default component.exports